"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionBodyItemType = exports.NetworkId = exports.WitnessType = exports.CertificateType = exports.PlutusScriptType = exports.HashType = void 0;
var HashType;
(function (HashType) {
    HashType[HashType["ADDRESS"] = 0] = "ADDRESS";
    HashType[HashType["SCRIPT"] = 1] = "SCRIPT";
})(HashType = exports.HashType || (exports.HashType = {}));
var PlutusScriptType;
(function (PlutusScriptType) {
    PlutusScriptType["PlutusScriptV1"] = "PlutusScriptV1";
    // PlutusScriptV2 = "PlutusScriptV2", upcoming
})(PlutusScriptType = exports.PlutusScriptType || (exports.PlutusScriptType = {}));
var CertificateType;
(function (CertificateType) {
    CertificateType[CertificateType["STAKE_REGISTRATION"] = 0] = "STAKE_REGISTRATION";
    CertificateType[CertificateType["STAKE_DE_REGISTRATION"] = 1] = "STAKE_DE_REGISTRATION";
    CertificateType[CertificateType["STAKE_DELEGATION"] = 2] = "STAKE_DELEGATION";
})(CertificateType = exports.CertificateType || (exports.CertificateType = {}));
var WitnessType;
(function (WitnessType) {
    WitnessType[WitnessType["V_KEY_WITNESS"] = 0] = "V_KEY_WITNESS";
    WitnessType[WitnessType["NATIVE_SCRIPT"] = 1] = "NATIVE_SCRIPT";
    WitnessType[WitnessType["PLUTUS_SCRIPT"] = 3] = "PLUTUS_SCRIPT";
    WitnessType[WitnessType["PLUTUS_DATA"] = 4] = "PLUTUS_DATA";
    WitnessType[WitnessType["REDEEMER"] = 5] = "REDEEMER";
})(WitnessType = exports.WitnessType || (exports.WitnessType = {}));
var NetworkId;
(function (NetworkId) {
    NetworkId[NetworkId["MAINNET"] = 1] = "MAINNET";
    NetworkId[NetworkId["TESTNET"] = 0] = "TESTNET";
})(NetworkId = exports.NetworkId || (exports.NetworkId = {}));
var TransactionBodyItemType;
(function (TransactionBodyItemType) {
    TransactionBodyItemType[TransactionBodyItemType["INPUTS"] = 0] = "INPUTS";
    TransactionBodyItemType[TransactionBodyItemType["OUTPUTS"] = 1] = "OUTPUTS";
    TransactionBodyItemType[TransactionBodyItemType["FEE"] = 2] = "FEE";
    TransactionBodyItemType[TransactionBodyItemType["TTL"] = 3] = "TTL";
    TransactionBodyItemType[TransactionBodyItemType["CERTIFICATES"] = 4] = "CERTIFICATES";
    TransactionBodyItemType[TransactionBodyItemType["WITHDRAWALS"] = 5] = "WITHDRAWALS";
    TransactionBodyItemType[TransactionBodyItemType["AUXILIARY_DATA_HASH"] = 7] = "AUXILIARY_DATA_HASH";
    TransactionBodyItemType[TransactionBodyItemType["VALIDITY_INTERVAL_START"] = 8] = "VALIDITY_INTERVAL_START";
    TransactionBodyItemType[TransactionBodyItemType["MINT"] = 9] = "MINT";
    TransactionBodyItemType[TransactionBodyItemType["SCRIPT_DATA_HASH"] = 11] = "SCRIPT_DATA_HASH";
    TransactionBodyItemType[TransactionBodyItemType["COLLATERAL_INPUTS"] = 13] = "COLLATERAL_INPUTS";
    TransactionBodyItemType[TransactionBodyItemType["REQUIRED_SIGNERS"] = 14] = "REQUIRED_SIGNERS";
})(TransactionBodyItemType = exports.TransactionBodyItemType || (exports.TransactionBodyItemType = {}));
